// extracted by mini-css-extract-plugin
export default {"popup_wrapper":"index_popup_wrapper__xQYkN","popup_content":"index_popup_content__23cwo","image":"index_image__LjzHX","text":"index_text__qYUy7"};